import { render, staticRenderFns } from "./CustomerProfileEditModal.vue?vue&type=template&id=e6c5ff4e&"
import script from "./CustomerProfileEditModal.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports